import {
    getMenuByRouter,
    getTagFromRoute,
    tagEqual
} from '_u/helper'
import { deepTraverse } from 'es-sharp'
import camelcase from 'camelcase-web'
import config from '@/config'

// 主页名称
const { homeName } = config

// admin-app
export default function(Vue, options = {}) {
    var { state = {}, store } = options

    // check
    if (!store) {
        throw new Error("必需先创建store实例")
    }

    // 注册store.app模块
    store.registerModule('app', {
        state: {
            breadCrumbList: [],
            tagNavList: [],
            local: [],
            errorList: [],
            hasReadErrorPage: false,
            routerMethod: 'push',
        },
        getters: {
            errorCount: state => state.errorList.length,

            cacheList: state => {
                return state.tagNavList.length ?
                    state.tagNavList
                    .filter(item => !(item.meta && item.meta.notCache))
                    .map(item => camelcase(item.name, { pascalCase: true })) : []
            },
        },
        mutations: {
            setTagNavList(state, list) {
                let tagList = [...list]

                // 将首页排在第一
                let homeTagIndex = tagList.findIndex(item => item.name === homeName)
                if (homeTagIndex > 0) {
                    let homeTag = tagList.splice(homeTagIndex, 1)[0]
                    tagList.unshift(homeTag)
                }

                // tag不超过8个
                if (tagList.length > 8) {
                    tagList.splice(1, tagList.length - 8)
                }

                // 保存tags
                state.tagNavList = tagList
            },
            addTag(state, { route, type = 'unshift', oldRoute }) {
                let router = getTagFromRoute(route),
                    oldIndex = -1

                if (oldRoute) {
                    oldIndex = state.tagNavList.findIndex(v => tagEqual(v, oldRoute))
                }

                // 新增tag
                if (state.tagNavList.findIndex(v => tagEqual(v, router)) < 0) {
                    // 尾部追加
                    if (type === 'push' || type == "go") state.tagNavList.push(router)
                    // 替换
                    else if (type === "replace") {
                        state.tagNavList.splice(oldIndex, 1, router)
                    }
                    // 头部追加
                    else {
                        state.tagNavList.unshift(router)
                    }
                } else {
                    // 移除旧tag
                    if (type === "replace") {
                        state.tagNavList.splice(oldIndex, 1, router)
                    }
                }
            },
            setLocal(state, lang) {
                state.local = lang
            },
            addError(state, error) {
                state.errorList.push(error)
            },
            setHasReadErrorLoggerStatus(state, status = true) {
                state.hasReadErrorPage = status
            },
            setRouterMethod(state, method) {
                state.routerMethod = method
            },
        },
        actions: {
            // 设置tag标题
            setTagNavTitle({ state, commit }, { route, title }) {
                var list = [...state.tagNavList]
                var index = list.findIndex(v => tagEqual(v, route))

                if (index >= 0) {
                    list.splice(index, 1, Object.assign({}, list[index], { title }))
                }
                
                commit("setTagNavList", list)
            },

            setBreadCrumb({ state, getters, rootGetters }, route) {
                state.breadCrumbList = rootGetters.getRelativeRoutes(route)
            },
        }
    })
}